import { useReveal } from '../hooks/useReveal.js';
import { LogoMark } from '../components/LogoMark.js';
import { ParticleField } from '../components/ParticleField.js';
import { AppleIcon, PlayIcon } from '../components/icons.js';
import { APP_STORE_URL, PLAY_STORE_URL } from '@/lib/appStores.js';

export function FinalCTA() {
  const ref = useReveal<HTMLDivElement>(0.25);

  return (
    <section
      id="get-the-app"
      className="relative w-full overflow-hidden"
      data-theme="dark"
      style={{
        // Always candle-lit dark, regardless of root theme.
        background: '#0B0F14',
        color: '#E8E6E3',
        padding: '76px 20px',
      }}
    >
      {/* Force dark token values for this section's children */}
      <style>{`
        #get-the-app {
          --color-bg: #0B0F14;
          --color-bg-elevated: #121821;
          --color-bg-subtle: #0F141B;
          --color-text-primary: #E8E6E3;
          --color-text-secondary: #A0A6B1;
          --color-text-muted: #6B7280;
          --color-gold: #D6B25E;
          --color-gold-soft: #E5C683;
          --color-gold-glow: rgba(214, 178, 94, 0.18);
          --color-border: #1E2630;
          --color-border-strong: #2A3340;
        }
      `}</style>

      {/* gold-glow */}
      <div
        aria-hidden
        className="absolute pointer-events-none"
        style={{
          width: 900,
          height: 900,
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          background: 'radial-gradient(closest-side, rgba(214,178,94,0.18), transparent 70%)',
        }}
      />
      <ParticleField count={25} />

      <div ref={ref} className="ow-reveal relative z-10 mx-auto max-w-[640px] text-center">
        <div className="flex justify-center">
          <LogoMark size={80} animateDraw={false} withHalo />
        </div>
        <p
          className="font-display uppercase mt-8"
          style={{ fontSize: 11, letterSpacing: '0.32em', color: '#D6B25E' }}
        >
          § X - Begin
        </p>
        <h2
          className="font-display mt-5"
          style={{
            fontSize: 'clamp(32px, 5vw, 48px)',
            fontWeight: 500,
            letterSpacing: '0.02em',
            color: '#E8E6E3',
          }}
        >
          Begin the day differently.
        </h2>
        <p className="scripture mt-4" style={{ fontSize: 22, lineHeight: 1.55, color: '#A0A6B1' }}>
          “Open it once. See if it stays.”
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ow-cta-primary"
            style={{ background: '#D6B25E' }}
          >
            <AppleIcon /> Download for iOS
          </a>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ow-cta-primary"
            style={{ background: '#D6B25E' }}
          >
            <PlayIcon /> Download for Android
          </a>
          <a
            href="/today"
            className="ow-cta-ghost"
            style={{ color: '#E8E6E3', borderColor: '#2A3340' }}
          >
            Open the Web App
          </a>
        </div>

        <p className="mt-6" style={{ fontSize: 12, color: '#6B7280' }}>
          Free. No account required to start.
        </p>
      </div>
    </section>
  );
}
